import React from "react";
import { Form } from "react-bootstrap";
import { TDirectionOption } from "../../../../../api/endpoints/SubsetOption";
import CheckboxListSelector from "../../../CheckboxListSelector";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TDirectionOption;
}

const DirectionField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="direction">
      <Form.Label>Directions</Form.Label>
      <CheckboxListSelector
        options={spec.value.direction}
        values={formik.values.direction}
        name="direction"
        onChange={values => formik.setFieldValue('direction', values.sort())}
      />

      <FormError
        message={formik.errors.direction as TFormErrorMessage}
        when={formik.touched.direction && Boolean(formik.errors.direction)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default DirectionField;
